var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      staticClass: "input",
      attrs: { id: _vm.id, type: "radio" },
      domProps: { checked: _vm.isSelected },
      on: { click: _vm.handleChange },
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "label-wrapper", attrs: { for: _vm.id } },
      [
        _vm.icon !== "null"
          ? _c(
              "icon-base",
              {
                staticClass: "icon",
                attrs: { width: "20px", height: "20px", iconName: _vm.label },
              },
              [_c(_vm.icon, { tag: "component" })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }